const maui = require("./maui");
const maui2019 = require("./maui2019");
const maui2021 = require("./maui2021");
const cancun = require("./cancun");
const cancun2020 = require("./cancun2020");
const cancun2021 = require("./cancun2021");
const kauai2019 = require("./kauai2019");
const kauai2021 = require("./kauai2021");

module.exports = {
  maui2021,
  kauai2021,
  cancun2020,
  cancun2021,
  maui2019,
  kauai2019,
  maui,
  cancun,
};



// WEBPACK FOOTER //
// ./lib/trips/index.js